import instance from '../instance'
export default class ProjectClass {
  static getMany() {
    return instance({
      url: `${process.env.REACT_APP_API_KEY}/api/projectClasses`,
      method: 'GET'
    })
  }
}
